var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCplusplus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 150,
    viewBox: "0 0 133 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cplusplus",
    clipPath: "url(#clip0_225_144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M132.993 44.1C132.992 41.5778 132.455 39.3491 131.368 37.4363C130.3 35.5554 128.701 33.9789 126.556 32.7325C108.85 22.4877 91.1265 12.2742 73.4263 2.01897C68.6544 -0.745487 64.0277 -0.644705 59.2912 2.15944C52.2436 6.33015 16.9592 26.6156 6.44492 32.7267C2.11483 35.2421 0.00780571 39.0917 0.00676495 44.0953C0 64.6982 0.00676495 85.3006 0 105.904C0.00104076 108.371 0.515697 110.556 1.5549 112.44C2.62324 114.378 4.24475 115.998 6.43919 117.273C16.954 123.384 52.2431 143.668 59.2891 147.839C64.0277 150.645 68.6544 150.745 73.4278 147.98C91.1286 137.724 108.853 127.511 126.561 117.266C128.756 115.992 130.377 114.371 131.446 112.435C132.483 110.551 132.999 108.366 133 105.898C133 105.898 133 64.7034 132.993 44.1",
    fill: "#5C8DBC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M66.7033 74.7988L1.55469 112.44C2.62303 114.378 4.24454 115.998 6.43899 117.273C16.9538 123.384 52.243 143.668 59.2889 147.839C64.0275 150.645 68.6542 150.745 73.4277 147.98C91.1285 137.724 108.853 127.511 126.561 117.266C128.756 115.992 130.377 114.371 131.446 112.435L66.7033 74.7988",
    fill: "#1A4674"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M47.4072 85.9485C51.1982 92.5896 58.3248 97.0689 66.5 97.0689C74.7257 97.0689 81.8929 92.5327 85.6646 85.8206L66.7035 74.7988L47.4072 85.9485",
    fill: "#1A4674"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M132.993 44.1007C132.992 41.5785 132.455 39.3498 131.368 37.437L66.7036 74.7996L131.446 112.436C132.483 110.552 132.999 108.366 133 105.899C133 105.899 133 64.7041 132.993 44.1007",
    fill: "#1B598E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M129.433 77.4893H124.374V82.567H119.314V77.4893H114.255V72.4131H119.314V67.3364H124.374V72.4131H129.433V77.4893ZM110.973 77.4893H105.914V82.567H100.855V77.4893H95.7959V72.4131H100.855V67.3364H105.914V72.4131H110.973V77.4893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M85.6645 85.8212C81.8928 92.5334 74.7255 97.0696 66.4999 97.0696C58.3247 97.0696 51.1981 92.5903 47.4071 85.9491C45.5027 82.6167 44.5025 78.8414 44.5065 74.9999C44.5065 62.8115 54.3537 52.9306 66.4999 52.9306C74.6225 52.9306 81.7117 57.3541 85.5214 63.9274L104.745 52.8194C97.104 39.584 82.8388 30.6797 66.4999 30.6797C42.1065 30.6797 22.3325 50.5228 22.3325 74.9999C22.3325 83.0301 24.4614 90.5606 28.1821 97.056C35.8036 110.361 50.1094 119.321 66.4999 119.321C82.9205 119.321 97.2487 110.325 104.859 96.9809L85.6645 85.8212Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_225_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 133,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCplusplus);
export default __webpack_public_path__ + "static/media/cplusplus.3fb5ede0fa904b7325c114ce7e66ef6d.svg";
export { ForwardRef as ReactComponent };